module.exports = {
	"0": "0x9e8f27fdcbf468b2fe0b7fe8b4d0a1707de0efd7",
	"1": "0x1ab58f78073fb467c8e50fed0c228c8549b22240",
	"2": "0x6e87ab1895f4d7d882d6384d0510ff38f6569a6a",
	"3": "0xd13284e1808ac1e8a5208799c5971f0ba86e2001",
	"4": "0x9dc253063c29470001b41dd40c019007d166de35",
	"5": "0xd0c9a16161365371fdfadf19e9ebc6d760c18737",
	"6": "0xa904f0d28d3e6c4f8404ab2fb26ffc72ac947bc8",
	"7": "0x5a5c66accde55765ae10a4bad1f436b6f404ab1e",
	"8": "0x0290fb167208af455bb137780163b7b7a9a10c16",
	"9": "0x9b1f7f645351af3631a656421ed2e40f2802e6c0",
	"10": "0x67b5656d60a809915323bf2c40a8bef15a152e3e",
	"11": "0x2612af3a521c2df9eaf28422ca335b04adf3ac66",
	"12": "0xa57b8a5584442b467b4689f1144d269d096a3daf",
	"13": "0x26b4afb60d6c903165150c6f0aa14f8016be4aec",
	"14": "0x630589690929e9cdefdef0734717a9ef3ec7fcfe",
	"15": "0x0e696947a06550def604e82c26fd9e493e576337",
	"16": "0xdb56f2e9369e0d7bd191099125a3f6c370f8ed15",
	"17": "0xa94b7f0465e98609391c623d0560c5720a3f2d33",
	"18": "0x6ed79aa1c71fd7bdbc515efda3bd4e26394435cc",
	"19": "0xb09bcc172050fbd4562da8b229cf3e45dc3045a6",
	"20": "0xfc628dd79137395f3c9744e33b1c5de554d94882",
	"ethernaut": "0x2834bcb0b71b9a95e2acf78a589ad94506523457"
};


//////////////////
// WEBPACK FOOTER
// ./gamedata/deploy.local.json
// module id = 1058
// module chunks = 0